import DisplayFrameworkInput from './components/DisplayFrameworkInput';
import DisplayFrameworkProvider from './components/DisplayFrameworkProvider';

const DisplayFramework = {
  Input: DisplayFrameworkInput,
  Provider: DisplayFrameworkProvider,
};

const DF:any = DisplayFramework;

export default DF;
